module.exports = {"230903031":"祥和社区公共服务站","230903032":"运管社区公共服务站","230903033":"安康社区公共服务站","230903034":"文苑社区公共服务站","230903035":"朝阳社区公共服务站","230903036":"东正社区公共服务站","230903037":"旭日社区公共服务站","230903038":"花园社区公共服务站","230903039":"银泉社区公共服务站","230903040":"运销社区公共服务站","230903041":"同仁社区公共服务站","230903042":"东方社区公共服务站","230903043":"学府社区公共服务站","230903044":"桃山社区公共服务站","230903045":"长青社区公共服务站","230903100":"万宝河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230903.json
// module id = 770
// module chunks = 0